// Module
var code = `<customer-page>
  <customer-loan-create-details ng-form="\$ctrl.loanForm"
                                loan="\$ctrl.loanInput"
                                loan-type-id="\$ctrl.loanTypeId"
                                edit-mode="true">
  </customer-loan-create-details>

  <div class="alert-container">
    <div class="alert alert--danger" ng-if="\$ctrl.displayEmptyReceiptMessage">
      <span>User has no available official receipts</span>
    </div>
  </div>

  <div class="override" ng-if="\$ctrl.isReconstruction() && \$ctrl.autoOfficialReceiptEnabled && \$ctrl.officialReceipt">
    <span class="key">Official receipt:</span>
    <span class="value"><input disabled type="text" ng-model="\$ctrl.officialReceipt.receiptNumber"/></span>
  </div>

  <div class="summary-actions">
    <button type="button" class="btn btn-warning"
            ng-click="\$ctrl.redirectBack()">
      Cancel
    </button>
    <button ng-if="!\$ctrl.isReconstruction() "type="button" class="btn btn-primary"
            ng-click="\$ctrl.restructure()"
            ng-disabled="\$ctrl.loanForm.\$invalid || \$ctrl.displayEmptyReceiptMessage">
      Restructure
    </button>
    <button ng-if="\$ctrl.isReconstruction()" type="button" class="btn btn-primary"
            ng-click="\$ctrl.reconstruct()"
            ng-disabled="\$ctrl.loanForm.\$invalid || \$ctrl.displayEmptyReceiptMessage">
      Reconstruct
    </button>
  </div>
</customer-page>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/customer-loan-restructure-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;